module.exports = __webpack_public_path__ + "static/media/Product_Photos_Ice_Cream.c336e3df.png";